module.exports = import("/forms-ui/federation/remoteEntry.js");